export const selectIsOpenSideBar = state => state.dashboard.sideBarState !== null;
export const selectSideBarState = state => state.dashboard.sideBarState;
export const selectIsOpenMarketsSideBar = state => state.dashboard.isOpenMarketsSideBar;
